var map = {
	"./img_gzhj1.jpg": "0gO9",
	"./img_gzhj1_2x.jpg": "s9O2",
	"./img_gzhj2.jpg": "KOKv",
	"./img_gzhj2_2x.jpg": "y2c9",
	"./img_gzhj3.jpg": "LjCY",
	"./img_gzhj3_2x.jpg": "TV5h",
	"./img_gzhj4.jpg": "Bx3p",
	"./img_gzhj4_2x.jpg": "QsaJ"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "hDfu";


//////////////////
// WEBPACK FOOTER
// ./src/components/open/panels/aboutus/img ^\.\/img_gzhj.*\.jpg$
// module id = hDfu
// module chunks = 0